import { render, staticRenderFns } from "./VuexInspect.vue?vue&type=template&id=50fc0ab8"
import script from "./VuexInspect.vue?vue&type=script&lang=js"
export * from "./VuexInspect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports